
export const API_HOST = process.env.API_HOST || "";
console.log("API_HOST", API_HOST);
